import { render, staticRenderFns } from "./CrudOrders.vue?vue&type=template&id=a67d3d1a&scoped=true&"
import script from "./CrudOrders.vue?vue&type=script&lang=js&"
export * from "./CrudOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67d3d1a",
  null
  
)

export default component.exports